import { AmountField } from '@ovComponents/3-pattern/amountField/amountField';
import { FieldRequiredType } from '@ovComponents/4-module/configurableOptionFields/basicField';
import { toAmountCents } from '@ovComponents/4-module/workflowCompletion/subSteps/utils/depositAmountRules';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { useTranslation } from 'react-i18next';
import { useLocalization } from '../../../../../../hooks/useLocalization';

type AmountFieldOption = {
  required?: FieldRequiredType;
  label?: unknown;
};

export type DepositExternalTransferAmountProp = {
  deposit: TransferContextData;
  options: { amountCents?: AmountFieldOption };
  focused: string[];
  onFocus: (field: string) => void;
  onChange: (value: Partial<TransferContextData>) => void;
  amountError: { hasError: boolean; errorMessage: string };
};

export const DepositExternalTransferAmount = ({
  deposit,
  options,
  focused,
  onFocus,
  onChange,
  amountError,
}: DepositExternalTransferAmountProp) => {
  const { t } = useTranslation('workflowCompletions');
  const { translateBackendString } = useLocalization();

  return (
    <AmountField
      useFormatAmountValueCents
      testId='deposit-form-amount-cents'
      label={
        deposit?.transferType === 'ALL_IN_CASH'
          ? t('depositReview.estimatedAmountLabel')
          : translateBackendString(options?.amountCents?.label)
      }
      setAmount={(e: any) =>
        onChange({
          amountCents: toAmountCents(e),
        })
      }
      amount={deposit?.amountCents}
      onBlur={() => onFocus('amountCents')}
      error={
        (!deposit?.amountCents &&
          focused.includes('amountCents') &&
          options?.amountCents?.required !== FieldRequiredType.NOT_REQUIRED) ||
        (amountError.hasError && focused.includes('amountCents'))
      }
      errorText={amountError.hasError ? amountError.errorMessage : undefined}
    />
  );
};
